var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppviewWithNavigationAndTabs',{attrs:{"top":""}},[_c('div',{staticClass:"flex flex-row flex-wrap justify-center align-center w-full md:w-10/12 lg:w-8/12 xl:w-6/12 mx-auto my-12"},[_c('DomainsList',{staticClass:"w-full my-5"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }